import { Pipe, PipeTransform } from '@angular/core';
import { BaseDateService } from '../services/base-date.service';

type DateLike = string | number | Date | null | undefined;

@Pipe({ name: 'baseDaysDifference' })
export class BaseDaysDifferencePipe implements PipeTransform {
  transform(dateTo: DateLike, dateFrom: DateLike): number {
    const from = this.toValidDate(dateFrom);
    const to = this.toValidDate(dateTo);

    if (!from || !to) {
      return 0;
    }

    return BaseDateService.differenceInDays(from, to) + 1;
  }

  private toValidDate(value: unknown): Date | null {
    if (value instanceof Date && !isNaN(value.getTime())) {
      return value;
    }

    if (typeof value === 'string' || typeof value === 'number') {
      const d = new Date(value);
      return isNaN(d.getTime()) ? null : d;
    }

    return null;
  }
}
